<script lang="ts">
	import { Button, Modal } from 'flowbite-svelte';

	import { deviceWidth, languageModal } from '$lib/stores';

	const close = () => {
		languageModal.set(null)
	};

	const getModalSize = (width): 'xs' | 'sm' | 'md' | 'lg' | 'xl' => {

		if (width >= 1366) {
			return 'md';
		}

		return 'lg';
	};

  $: desc1 = {
    'ru': 'В скором времени вы сможете ознакомиться с сайтом не только на русском, но и на татарском и башкирском языках.',
    'tt': 'Тиздән сез сайт белән рус телендә генә түгел, татар һәм башкорт телләрендә дә таныша аласыз.',
    'ba': 'Тиҙҙән һеҙ сайт менән рус телендә генә түгел, татар һәм башҡорт телдәрендә лә таныша алаһығыҙ.',
    'en': 'Soon you will be able to familiarize yourself with the site not only in Russian, but also in Tatar and Bashkir languages.'
  }[$languageModal || ''];

  $: desc2 = {
    'ru': 'Наши специалисты стараются для того, что бы вам было интересно.',
    'tt': 'Безнең белгечләр сезгә кызык булсын өчен тырышалар.',
    'ba': 'Белгестәрегеҙ һеҙҙе ҡыҙыҡһындырыр өсөн тырыша.',
    'en': 'Our experts are trying to make it interesting for you.'
  }[$languageModal || ''];

  $: btnText = {
    'ru': 'Хорошо',
    'tt': 'Яҡшы',
    'ba': 'Яхшы',
    'en': 'Ok'
  }[$languageModal || ''];
</script>

<Modal
  open={true}
	size={getModalSize($deviceWidth)}
	on:close={close}
  on:hide={close}
	autoclose={false}
	outsideclose
	defaultClass="relative flex flex-col mx-auto rounded-[14px] 6xl:rounded-[20px] 2xl:px-6 pt-4 pb-4 leading-[1.25] text-[#262627]"
>
  <p class="font-semibold">{desc1}</p>

  <p class="max-w-[320px] font-medium">{desc2}</p>

  <div class="flex justify-end">
    <Button
      type="button"
      class="bg-blue-400 hover:bg-blue-400 focus:ring-0 !p-0 text-[16px] 2xl:text-[11.383px] 3xl:text-[12px] 5xl:text-[13.333px] 6xl:text-[16px] w-[120px] h-[42px] 2xl:h-[29.881px] 3xl:h-[31.5px] 5xl:h-[35px] 6xl:h-[42px] rounded-[10px] 2xl:rounded-[7.115px] 3xl:rounded-[7.5px] 5xl:rounded-[8.333px] 6xl:rounded-[10px]"
      on:click={close}
    >
      {btnText}
    </Button>
  </div>
</Modal>
